export const STATUSES = {
  EMPTY: "empty",
  FOCUS: "focus",
  FILLED: "filled",
  LOAD: "load",
  LOAD_END: "load_end",
  LOAD_ERROR: "load_error",
  COMPLETE: "complete",
  APPROVE: "approve"
};
